import React, { useState, useEffect, useRef } from "react";
import TopBar from "../../components/TopBar/TopBar";
import { MainBodyStyle } from "../../styles/MainBodyStyles";
import Footer from "../../components/footer/Footer";
import { HeadingStyle } from "../../styles/HeadingStyles";
import { TextErrorStyle } from "../../styles/ErrorStyles";
import { toast } from "react-toastify";
import { SponsorValidationSchema } from "../../validations/SponsorValidation";
import { SponsorPageStyle } from "./Configuration.style";
import api from "../../api/configAxios";
import { useSelector } from "react-redux";
import Controller from "../../common/controller";
import { useNavigate } from "react-router-dom";
import DurationSelector from "../../components/sponsors/DurationSelector";
import {
  getCurrentUTCTimeWithMicroseconds,
  toUTCWithMicroseconds,
} from "../../common/ConvertTime";
import ROUTE from "../../common/Routes";
import { getSlotUsageFromAccountList, isSlotTaken } from "../../Utils/sponsorSlots";



const SponsorPage = () => {
  const fileInputRef = useRef(null);
  const { access_token } = useSelector((state) => state.userKeyRed);
  const today = new Date().toISOString().split("T")[0];
  const navigate = useNavigate();

  const [sponsorName, setSponsorName] = useState("");
  const [sponsorLogo, setSponsorLogo] = useState();
  const [startDay, setStartDay] = useState("");
  const [endDay, setEndDay] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  const [errors, setErrors] = useState();
  const [slotdata, setSlotData] = useState([]);
  const [isWeeklyEmail, setIsWeeklyEmail] = useState(false);
  const [logoSlot, setLogoSlot] = useState();
  const [isNotificationsAvailable, setIsNotificationsAvailable] =
    useState(true);

  const [durationList, setDurationList] = useState([30, 90, 180, 365]);
  const [isLockScreenWidget, setIsLockScreenWidget] = useState(false);
  const [lockScreenWidgetDuration, setLockScreenWidgetDuration] = useState("");
  const [lockScreenWidgetStart, setLockScreenWidgetStart] = useState("");
  const [lockScreenWidgetEnd, setLockScreenWidgetEnd] = useState("");

  const [isHomeScreenWidget, setIsHomeScreenWidget] = useState(false);
  const [homeScreenWidgetDuration, setHomeScreenWidgetDuration] = useState("");
  const [homeScreenWidgetStart, setHomeScreenWidgetStart] = useState("");
  const [homeScreenWidgetEnd, setHomeScreenWidgetEnd] = useState("");

  const [isAppSplashScreen, setIsAppSplashScreen] = useState(false);
  const [appSplashDuration, setAppSplashDuration] = useState("");
  const [appSplashStart, setAppSplashStart] = useState("");
  const [appSplashEnd, setAppSplashEnd] = useState("");

  const [isAppScrollBanner, setIsAppScrollBanner] = useState(false);
  const [appScrollBannerDuration, setAppScrollBannerDuration] = useState("");
  const [appScrollBannerStart, setAppScrollBannerStart] = useState("");
  const [appScrollBannerEnd, setAppScrollBannerEnd] = useState("");

  const [isMovementNotification, setIsMovementNotification] = useState(false);
  const [movementNotifDuration, setMovementNotifDuration] = useState("");
  const [movementNotifStart, setMovementNotifStart] = useState("");
  const [movementNotifEnd, setMovementNotifEnd] = useState("");

  const [isSafetyEmergencyNotification, setIsSafetyEmergencyNotification] =
    useState(false);
  const [safetyEmergencyNotifDuration, setSafetyEmergencyNotifDuration] =
    useState("");
  const [safetyEmergencyNotifStart, setSafetyEmergencyNotifStart] =
    useState("");
  const [safetyEmergencyNotifEnd, setSafetyEmergencyNotifEnd] = useState("");

  const [weeklyNotifDuration, setWeeklyNotifDuration] = useState("");
  const [weeklyNotifStart, setWeeklyNotifStart] = useState("");
  const [weeklyNotifEnd, setWeeklyNotifEnd] = useState("");

  const [isWeeklySystemReport, setIsWeeklySystemReport] = useState(false);
  const [weeklySystemReportDuration, setWeeklySystemReportDuration] =
    useState("");
  const [weeklySystemReportStart, setWeeklySystemReportStart] = useState("");
  const [weeklySystemReportEnd, setWeeklySystemReportEnd] = useState("");
  const [weeklySystemReportSlot, setWeeklySystemReportSlot] = useState("");

  const [
    isWeeklySystemReportNotifications,
    setIsWeeklySystemReportNotifications,
  ] = useState(false);
  const [weeklySystemReportNotifDuration, setWeeklySystemReportNotifDuration] =
    useState("");
  const [weeklySystemReportNotifStart, setWeeklySystemReportNotifStart] =
    useState("");
  const [weeklySystemReportNotifEnd, setWeeklySystemReportNotifEnd] =
    useState("");
    const accountList = useSelector(state => state.sponsors?.accountList) || [];
    // Get all used slots from backend response
const usedSlots = getSlotUsageFromAccountList(accountList);
console.log("Used slots for validation:", usedSlots);



  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const Errors = (err) => {
    const element = err[0];

    const [code, message] = element.split(":");
    switch (code) {
      case "0":
        setErrors(message);
        break;
      case "1":
        setErrors(message);
        break;
      case "2":
        setErrors(message);
        break;
      case "3":
        setErrors(message);
        break;
      case "4":
        setErrors(message);
        break;
      case "5":
        setErrors(message);
        break;
      case "6":
        setErrors(message);
        break;
      case "7":
        setErrors(message);
        break;
      case "8":
        setErrors(message);
        break;
      case "9":
        setErrors(message);
        break;
      case "10":
        setErrors(message);
        break;
      case "11":
        setErrors(message);
        break;
      case "12":
        setErrors(message);
        break;
      default:
        break;
    }
  };

  const resetSponsorForm = () => {
    setSponsorName("");
    setSponsorLogo(undefined);
    setStartDay("");
    setEndDay("");
    setErrors("");
    setIsLockScreenWidget(false);
    setIsHomeScreenWidget(false);
    setIsAppSplashScreen(false);
    setIsAppScrollBanner(false);
    setIsMovementNotification(false);
    setIsSafetyEmergencyNotification(false);
    setIsWeeklyEmail(false);
    setIsWeeklySystemReport(false);
    setIsWeeklySystemReportNotifications(false);

    setLogoSlot("");
    setLockScreenWidgetDuration("");
    setLockScreenWidgetStart("");
    setLockScreenWidgetEnd("");
    setHomeScreenWidgetDuration("");
    setHomeScreenWidgetStart("");
    setHomeScreenWidgetEnd("");
    setAppSplashDuration("");
    setAppSplashStart("");
    setAppSplashEnd("");
    setAppScrollBannerDuration("");
    setAppScrollBannerStart("");
    setAppScrollBannerEnd("");
    setMovementNotifDuration("");
    setMovementNotifStart("");
    setMovementNotifEnd("");
    setSafetyEmergencyNotifDuration("");
    setSafetyEmergencyNotifStart("");
    setSafetyEmergencyNotifEnd("");
    setWeeklyNotifDuration("");
    setWeeklyNotifStart("");
    setWeeklyNotifEnd("");
    setWeeklySystemReportDuration("");
    setWeeklySystemReportStart("");
    setWeeklySystemReportEnd("");
    setWeeklySystemReportSlot("");
    setWeeklySystemReportNotifDuration("");
    setWeeklySystemReportNotifStart("");
    setWeeklySystemReportNotifEnd("");
    setIsNotificationsAvailable(true);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    navigate(ROUTE.Analytics);
  };
  const addSponsor = async (val) => {
    try {
      var response = await api.post(`${Controller.Sponsor}/addSponsor`, val, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + access_token,
        },
      });

      const data = response.data;
      toast("Sponsor added successfully");
      resetSponsorForm();
    } catch (error) {
      if (error.response.status == 401) {
        toast.error("Token has expired.", {
          bodyClassName: "notification-div-error",
          progressClassName: "progress-bar-error",
        });
      } else {
        toast.error("Error has Ocurred.Try Again", {
          bodyClassName: "notification-div-error",
          progressClassName: "progress-bar-error",
        });
      }
    }
    setBtnDisable(false);
  };

  const buildSponsorPlacementRequests = () => {
    const requests = [];

    if (isLockScreenWidget) {
      requests.push({
        startDate: toUTCWithMicroseconds(lockScreenWidgetStart),
        endDate: toUTCWithMicroseconds(lockScreenWidgetEnd),
        isActive: true,
        sponsorPlacementType: "Widget",
        weeklyEmailSlot: "0",
        dateCreated: getCurrentUTCTimeWithMicroseconds(),
        dateUpdated: getCurrentUTCTimeWithMicroseconds(),
        Slot: "0",
        duration: lockScreenWidgetDuration,
      });
    }
 
    if (isAppSplashScreen) {
      requests.push({
        startDate: toUTCWithMicroseconds(appSplashStart),
        endDate: toUTCWithMicroseconds(appSplashEnd),
        isActive: true,
        sponsorPlacementType: "Splash",
        weeklyEmailSlot: "0",
        dateCreated: getCurrentUTCTimeWithMicroseconds(),
        dateUpdated: getCurrentUTCTimeWithMicroseconds(),
        Slot: "0",
        duration: appSplashDuration,
      });
    }
    if (isAppScrollBanner) {
      requests.push({
        startDate: toUTCWithMicroseconds(appScrollBannerStart),
        endDate: toUTCWithMicroseconds(appScrollBannerEnd),
        isActive: true,
        sponsorPlacementType: "App",
        weeklyEmailSlot: "0",
        dateCreated: getCurrentUTCTimeWithMicroseconds(),
        dateUpdated: getCurrentUTCTimeWithMicroseconds(),
        Slot: "0",
        duration: appScrollBannerDuration,
      });
    }
    if (isMovementNotification) {
      requests.push({
        startDate: toUTCWithMicroseconds(movementNotifStart),
        endDate: toUTCWithMicroseconds(movementNotifEnd),
        isActive: true,
        sponsorPlacementType: "Movement",
        weeklyEmailSlot: "0",
        dateCreated: getCurrentUTCTimeWithMicroseconds(),
        dateUpdated: getCurrentUTCTimeWithMicroseconds(),
        Slot: "0",
        duration: movementNotifDuration,
      });
    }
    if (isSafetyEmergencyNotification) {
      requests.push({
        startDate: toUTCWithMicroseconds(safetyEmergencyNotifStart),
        endDate: toUTCWithMicroseconds(safetyEmergencyNotifEnd),
        isActive: true,
        sponsorPlacementType: "SafetyEmergency",
        weeklyEmailSlot: "0",
        dateCreated: getCurrentUTCTimeWithMicroseconds(),
        dateUpdated: getCurrentUTCTimeWithMicroseconds(),
        Slot: "0",
        duration: safetyEmergencyNotifDuration,
      });
    }
    if (isWeeklyEmail) {
      requests.push({
        startDate: toUTCWithMicroseconds(weeklyNotifStart),
        endDate: toUTCWithMicroseconds(weeklyNotifEnd),
        isActive: true,
        sponsorPlacementType: "WeeklyReportEmail",
        weeklyEmailSlot: logoSlot,
        dateCreated: getCurrentUTCTimeWithMicroseconds(),
        dateUpdated: getCurrentUTCTimeWithMicroseconds(),
        Slot: "0",
        duration: weeklyNotifDuration,
      });
    }
    if (isWeeklySystemReportNotifications) {
      requests.push({
        startDate: toUTCWithMicroseconds(weeklySystemReportNotifStart),
        endDate: toUTCWithMicroseconds(weeklySystemReportNotifEnd),
        isActive: true,
        sponsorPlacementType: "WeeklySystemNotification",
        weeklyEmailSlot: "0",
        dateCreated: getCurrentUTCTimeWithMicroseconds(),
        dateUpdated: getCurrentUTCTimeWithMicroseconds(),
        Slot: "0",
        duration: weeklySystemReportNotifDuration,
      });
    }
    if (isWeeklySystemReport) {
      requests.push({
        startDate: toUTCWithMicroseconds(weeklySystemReportStart),
        endDate: toUTCWithMicroseconds(weeklySystemReportEnd),
        isActive: true,
        sponsorPlacementType: "WeeklySystemReport",
        weeklyEmailSlot: weeklySystemReportSlot,
        dateCreated: getCurrentUTCTimeWithMicroseconds(),
        dateUpdated: getCurrentUTCTimeWithMicroseconds(),
        Slot: "0",
        duration: weeklySystemReportDuration,
      });
    }

    return requests;
  };
  const validateForm = async () => {
    setErrors("");
    setBtnDisable(true);
    const formData = {
      mode:"add",
      Name: sponsorName,
      LogoImage: sponsorLogo,
      SponsorPlacementRequests: buildSponsorPlacementRequests(),
    };

    await SponsorValidationSchema.validate(formData, {
      abortEarly: false,
    })
      .then((value) => {
        addSponsor(value);
      })
      .catch((err) => {
        setBtnDisable(false);
        Errors(err.errors);
      });
  };

  return (
    <SponsorPageStyle>
      <TopBar authorized={true} />

      <MainBodyStyle>
        <HeadingStyle>Sponsors Configurations</HeadingStyle>
        <div className="configurationCardWidth configurationCard">
          <table className="table-div">
            <tbody>
              <tr className="row-div">
                <td>
                  <div className="field-div"> Sponsor Name:</div>
                </td>
                <td>
                  <input
                    value={sponsorName}
                    onChange={(e) => setSponsorName(e.target.value)}
                    type="text"
                    id="sponsorName"
                    maxLength={30}
                    placeholder="Enter Sponsor Name"
                    className="form-control mt-1 input-field"
                  />
                </td>
              </tr>

              <tr className="row-div">
                <td>
                  <div className="field-div-logo" style={{ paddingBottom: "55px" }}>Sponsor Logo:</div>
                </td>
                <td>
                  <input
                    type="file"
                    accept=".png,.svg"
                    id="sponsorLogo"
                    className="form-control mt-1 input-field"
                    ref={fileInputRef}
                    onChange={(e) => {
                      const file = e.target.files && e.target.files[0];
                      if (file) {
                        const allowedTypes = ["image/png", "image/svg+xml"];
                        if (!allowedTypes.includes(file.type)) {
                          toast.error("File type must be png or svg.", {
                            bodyClassName: "notification-div-error",
                            progressClassName: "progress-bar-error",
                          });
                          e.target.value = "";
                          return;
                        }
                        if (file.size > 500 * 1024) {
                          toast.error("File cannot be greater than 500 KB.", {
                            bodyClassName: "notification-div-error",
                            progressClassName: "progress-bar-error",
                          });
                          e.target.value = "";
                          return;
                        }
                        setSponsorLogo(file);
                      }
                    }}
                  />
                  <div
                    style={{ fontSize: 11, color: "#888", textAlign: "end" }}
                  >
                    <span
                      title="Logo must be a square image"
                      style={{
                        marginRight: 5,
                        color: "#888",
                        cursor: "pointer",
                      }}
                    >
                      <i className="bi bi-info-circle" />
                    </span>
                    <div>Supported formats: SVG, PNG</div>
                    <div>Logos must be monochrome and have transparent backgrounds</div>
                  </div>
                </td>
              </tr>

              {/* -------------- Lock Screen Widget --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>Home/Lock Screen Widget: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="LockScreenWidgetRadio"
                        id="isLockScreenWidgetTrue"
                        checked={isLockScreenWidget}
                        onChange={() => {
                          setIsLockScreenWidget(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isLockScreenWidgetTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="LockScreenWidgetRadio"
                        id="isLockScreenWidgetFalse"
                        checked={!isLockScreenWidget}
                        onChange={() => {
                          setIsLockScreenWidget(false);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isLockScreenWidgetFalse"
                      >
                        Disable
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              {isLockScreenWidget && (
                <DurationSelector
                  label="Lock Screen Widget"
                  duration={lockScreenWidgetDuration}
                  setDuration={setLockScreenWidgetDuration}
                  startDate={lockScreenWidgetStart}
                  setStartDate={setLockScreenWidgetStart}
                  endDate={lockScreenWidgetEnd}
                  setEndDate={setLockScreenWidgetEnd}
                  durationOptions={durationList}
                  minDate={today}
                />
              )}

              {/* -------------- App Splash Screen Widget --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>App Splash Screen: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="AppSplashScreenRadio"
                        id="isAppSplashScreenTrue"
                        checked={isAppSplashScreen}
                        onChange={() => {
                          setIsAppSplashScreen(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isAppSplashScreenTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="AppSplashScreenRadio"
                        id="isAppSplashScreenFalse"
                        checked={!isAppSplashScreen}
                        onChange={() => {
                          setIsAppSplashScreen(false);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isAppSplashScreenFalse"
                      >
                        Disable
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              {isAppSplashScreen && (
                <DurationSelector
                  label="App Splash Screen"
                  duration={appSplashDuration}
                  setDuration={setAppSplashDuration}
                  startDate={appSplashStart}
                  setStartDate={setAppSplashStart}
                  endDate={appSplashEnd}
                  setEndDate={setAppSplashEnd}
                  durationOptions={durationList}
                  minDate={today}
                />
              )}

              {/* -------------- App Scroll Banner --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>App Scroll Banner: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="AppScrollBannerRadio"
                        id="isAppScrollBannerTrue"
                        checked={isAppScrollBanner}
                        onChange={() => {
                          setIsAppScrollBanner(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isAppScrollBannerTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="AppScrollBannerRadio"
                        id="isAppScrollBannerFalse"
                        checked={!isAppScrollBanner}
                        onChange={() => {
                          setIsAppScrollBanner(false);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isAppScrollBannerFalse"
                      >
                        Disable
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              {isAppScrollBanner && (
                <DurationSelector
                  label="App Scroll Banner"
                  duration={appScrollBannerDuration}
                  setDuration={setAppScrollBannerDuration}
                  startDate={appScrollBannerStart}
                  setStartDate={setAppScrollBannerStart}
                  endDate={appScrollBannerEnd}
                  setEndDate={setAppScrollBannerEnd}
                  durationOptions={durationList}
                  minDate={today}
                />
              )}

              {/* -------------- Movement Notifications --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>Movement Notifications: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="MovementNotificationRadio"
                        id="isMovementNotificationTrue"
                        checked={isMovementNotification}
                        disabled={!isNotificationsAvailable}
                        onChange={() => {
                          setIsMovementNotification(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isMovementNotificationTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="MovementNotificationRadio"
                        id="isMovementNotificationFalse"
                        checked={!isMovementNotification}
                        onChange={() => {
                          setIsMovementNotification(false);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isMovementNotificationFalse"
                      >
                        Disable
                      </label>
                    </div>
                    <div className="form-check">
                      {!isNotificationsAvailable && (
                        <span style={{ color: "red", fontSize: 9 }}>
                          Not available in the selected time slot
                        </span>
                      )}
                    </div>
                  </div>
                </td>
              </tr>
              {isMovementNotification && (
                <DurationSelector
                  label="Movement Notification"
                  duration={movementNotifDuration}
                  setDuration={setMovementNotifDuration}
                  startDate={movementNotifStart}
                  setStartDate={setMovementNotifStart}
                  endDate={movementNotifEnd}
                  setEndDate={setMovementNotifEnd}
                  durationOptions={durationList}
                  minDate={today}
                />
              )}
              {/* -------------- Safety Emergency Notifications --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>Safety Emergency Notifications: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="SafetyEmergencyNotificationRadio"
                        id="isSafetyEmergencyNotificationTrue"
                        checked={isSafetyEmergencyNotification}
                        onChange={() => {
                          setIsSafetyEmergencyNotification(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isSafetyEmergencyNotificationTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="SafetyEmergencyNotificationRadio"
                        id="isSafetyEmergencyNotificationFalse"
                        checked={!isSafetyEmergencyNotification}
                        onChange={() => {
                          setIsSafetyEmergencyNotification(false);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isSafetyEmergencyNotificationFalse"
                      >
                        Disable
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              {isSafetyEmergencyNotification && (
                <DurationSelector
                  label="Safety Emergency Notifications"
                  duration={safetyEmergencyNotifDuration}
                  setDuration={setSafetyEmergencyNotifDuration}
                  startDate={safetyEmergencyNotifStart}
                  setStartDate={setSafetyEmergencyNotifStart}
                  endDate={safetyEmergencyNotifEnd}
                  setEndDate={setSafetyEmergencyNotifEnd}
                  durationOptions={durationList}
                  minDate={today}
                />
              )}

              {/* -------------- Weekly Report Email --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>Weekly Report Email: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="weeklyEmailRadio"
                        id="isWeeklyEmailTrue"
                        checked={isWeeklyEmail}
                        onChange={() => {
                          setIsWeeklyEmail(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isWeeklyEmailTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="weeklyEmailRadio"
                        id="isWeeklyEmailFalse"
                        checked={!isWeeklyEmail}
                        onChange={() => {
                          setIsWeeklyEmail(false);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isWeeklyEmailFalse"
                      >
                        Disable
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              {isWeeklyEmail && (
                <DurationSelector
                  label="Weekly Report Email"
                  duration={weeklyNotifDuration}
                  setDuration={setWeeklyNotifDuration}
                  startDate={weeklyNotifStart}
                  setStartDate={setWeeklyNotifStart}
                  endDate={weeklyNotifEnd}
                  setEndDate={setWeeklyNotifEnd}
                  durationOptions={durationList}
                  minDate={today}
                />
              )}
             {isWeeklyEmail && (
  <tr className="row-div">
    <td>
      <div className="field-div">Logo Slot:</div>
    </td>
    <td>
      <select
        className="form-control mt-1 input-field"
        value={logoSlot || ""}
        onChange={(e) => setLogoSlot(Number(e.target.value))}
        disabled={!(weeklyNotifStart && weeklyNotifEnd)}
      >
        <option value="" disabled>Select Slot</option>
        {[...Array(12)].map((_, i) => {
          const slot = i + 1;
          const slotUnavailable = isSlotTaken({
            usedSlots,
            slot,
            type: "WeeklyReportEmail",
            selectedStart: weeklyNotifStart || today,
            selectedEnd: weeklyNotifEnd || today,
            currentSponsorId: undefined,
          });
          if (slotUnavailable) {
            console.log(`Slot ${slot} is unavailable for WeeklyReportEmail`);
          }
          return (
            <option key={slot} value={slot} disabled={slotUnavailable}>
              {slot} {slotUnavailable ? "(Unavailable)" : ""}
            </option>
          );
        })}
      </select>
      {!(weeklyNotifStart && weeklyNotifEnd) && (
        <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>
          Please select start and end date first
        </div>
      )}
    </td>
  </tr>
)}

              {/* -------------- Weekly Report Notifications --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>Weekly System Report Notifications: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="WeeklySystemReportNotificationsRadio"
                        id="isWeeklySystemReportNotificationsTrue"
                        checked={isWeeklySystemReportNotifications}
                        onChange={() =>
                          setIsWeeklySystemReportNotifications(true)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isWeeklySystemReportNotificationsTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="WeeklySystemReportNotificationsRadio"
                        id="isWeeklySystemReportNotificationsFalse"
                        checked={!isWeeklySystemReportNotifications}
                        onChange={() =>
                          setIsWeeklySystemReportNotifications(false)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isWeeklySystemReportNotificationsFalse"
                      >
                        Disable
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              {isWeeklySystemReportNotifications && (
                <>
                  <DurationSelector
                    label="Weekly System Report Notifications"
                    duration={weeklySystemReportNotifDuration}
                    setDuration={setWeeklySystemReportNotifDuration}
                    startDate={weeklySystemReportNotifStart}
                    setStartDate={setWeeklySystemReportNotifStart}
                    endDate={weeklySystemReportNotifEnd}
                    setEndDate={setWeeklySystemReportNotifEnd}
                    durationOptions={durationList}
                    minDate={today}
                  />
                </>
              )}
              {/* -------------- Weekly System Report --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>Weekly System Report: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="WeeklySystemReportRadio"
                        id="isWeeklySystemReportTrue"
                        checked={isWeeklySystemReport}
                        onChange={() => setIsWeeklySystemReport(true)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isWeeklySystemReportTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="WeeklySystemReportRadio"
                        id="isWeeklySystemReportFalse"
                        checked={!isWeeklySystemReport}
                        onChange={() => setIsWeeklySystemReport(false)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isWeeklySystemReportFalse"
                      >
                        Disable
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              {isWeeklySystemReport && (
                <>
                  <DurationSelector
                    label="Weekly System Report"
                    duration={weeklySystemReportDuration}
                    setDuration={setWeeklySystemReportDuration}
                    startDate={weeklySystemReportStart}
                    setStartDate={setWeeklySystemReportStart}
                    endDate={weeklySystemReportEnd}
                    setEndDate={setWeeklySystemReportEnd}
                    durationOptions={durationList}
                    minDate={today}
                  />
                  <tr className="row-div">
                    <td>
                      <div className="field-div">Weekly System Report Slot:</div>
                    </td>
                    <td>
                      <select
                        className="form-control mt-1 input-field"
                        value={weeklySystemReportSlot || ""}
                        onChange={(e) => setWeeklySystemReportSlot(Number(e.target.value))}
                        disabled={!(weeklySystemReportStart && weeklySystemReportEnd)}
                      >
                        <option value="" disabled>Select Slot</option>
                        {[...Array(12)].map((_, i) => {
                          const slot = i + 1;
                          const slotUnavailable = isSlotTaken({
                            usedSlots,
                            slot,
                            type: "WeeklySystemReport",
                            selectedStart: weeklySystemReportStart || today,
                            selectedEnd: weeklySystemReportEnd || today,
                            currentSponsorId: undefined,
                          });
                          return (
                            <option key={slot} value={slot} disabled={slotUnavailable}>
                              {slot} {slotUnavailable ? "(Unavailable)" : ""}
                            </option>
                          );
                        })}
                      </select>
                      {!(weeklySystemReportStart && weeklySystemReportEnd) && (
                        <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>
                          Please select start and end date first
                        </div>
                      )}
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
          <button
            type="submit"
            className={"btn form-button"}
            disabled={btnDisable}
            onClick={validateForm}
          >
            Add Sponsor
          </button>
          {errors && <TextErrorStyle>{errors}</TextErrorStyle>}
        </div>
      </MainBodyStyle>
      <Footer style="footer" />
    </SponsorPageStyle>
  );
};

export default SponsorPage;
